/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_User_Role_DescriptionInputs */

const en_admin_settings_groups_user_role_description = /** @type {(inputs: Admin_Settings_Groups_User_Role_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default role for new users`)
};

/**
* | output |
* | --- |
* | "Default role for new users" |
*
* @param {Admin_Settings_Groups_User_Role_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_user_role_description = /** @type {((inputs?: Admin_Settings_Groups_User_Role_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_User_Role_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_user_role_description(inputs)
});
export { admin_settings_groups_user_role_description as "admin.settings.groups.user_role.description" }